import React, { Component } from "react";
import axios from "axios";
import Modal from "react-awesome-modal";
import Constants from "Helpers/Constants";
import { Grid } from "@mui/material";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import folderImg from "assets/images/folder.png";
import init from "Helpers/WindowToken";

export default class MediaPickerModal extends Component {
  state = {
    folders: [],
    images: [],
    selectedFolder: null,
    selectedImages: [],
  };

  componentDidMount() {
    this.getFolders();
  }

  getFolders = async () => {
    try {
      if (init() === "success") {
        const res = await axios.post(Constants.getUrls.getMediaFolderList);
        this.setState({ folders: res.data.data || [] });
      }
    } catch (err) {
      console.log(err);
    }
  };

  openFolder = async (folder) => {
    try {
      if (init() === "success") {
        const res = await axios.post(Constants.getUrls.getFolderImages, {
          folder_id: folder.id,
        });

        this.setState({
          selectedFolder: folder,
          images: res.data.data.images || [],
          selectedImages: [],
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleSelectImage = (img) => {
    const { multiple } = this.props;

    if (multiple) {
      this.setState((prev) => {
        const exists = prev.selectedImages.find((i) => i.id === img.id);

        return exists
          ? {
              selectedImages: prev.selectedImages.filter(
                (i) => i.id !== img.id
              ),
            }
          : {
              selectedImages: [...prev.selectedImages, img],
            };
      });
    } else {
      this.setState({ selectedImages: [img] });
    }
  };

  handleConfirm = () => {
    this.props.onSelect(this.state.selectedImages);
    this.props.onClose();
  };

  goBack = () => {
    this.setState({
      selectedFolder: null,
      images: [],
      selectedImages: [],
    });
  };

  render() {
    const { visible, onClose } = this.props;

    return (
      <Modal
        visible={visible}
        width="1100"
        height="650"
        effect="fadeInUp"
        onClickAway={onClose}
      >
        <div
          style={{
            padding: 25,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            color: "black",
          }}
        >
          {/* 🔥 Header */}
          <div
            style={{
              marginBottom: 20,
              display: "flex",
              alignItems: "center",
              gap: 15,
              borderBottom: "1px solid #eee",
              paddingBottom: 10,
            }}
          >
            {/* ✅ Back Button (LEFT SIDE - Better UX) */}
            {this.state.selectedFolder && (
              <MDButton
                variant="outlined"
                size="small"
                onClick={this.goBack}
                style={{color: "black"}}
              >
                ← Back
              </MDButton>
            )}

            <MDTypography variant="h5">
              {this.state.selectedFolder
                ? this.state.selectedFolder.folder_name
                : "Select Folder"}
            </MDTypography>
          </div>

          {/* 🔥 Content */}
          <div style={{ flex: 1, overflowY: "auto" }}>
            {/* 📁 Folder View */}
            {!this.state.selectedFolder && (
              <Grid container spacing={3}>
                {this.state.folders.map((folder) => (
                  <Grid item xs={3} key={folder.id}>
                    <div
                      onClick={() => this.openFolder(folder)}
                      style={{
                        borderRadius: 12,
                        padding: 20,
                        cursor: "pointer",
                        background: "#f9fafc",
                        transition: "0.3s",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        display: "flex",
                        alignItems: "center",
                        gap: 15,
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      <img src={folderImg} style={{ height: 50 }} />
                      <MDTypography variant="button" style={{color: "black"}}>
                        {folder.folder_name}
                      </MDTypography>
                    </div>
                  </Grid>
                ))}
              </Grid>
            )}

            {/* 🖼️ Image View */}
            {this.state.selectedFolder && (
              <Grid container spacing={3}>
                {this.state.images.map((img) => {
                  const isSelected = this.state.selectedImages.find(
                    (i) => i.id === img.id
                  );

                  return (
                    <Grid item xs={2} key={img.id}>
                      <div
                        onClick={() => this.handleSelectImage(img)}
                        style={{
                          borderRadius: 12,
                          overflow: "hidden",
                          cursor: "pointer",
                          position: "relative",
                          border: isSelected
                            ? "3px solid #1976d2"
                            : "1px solid #ddd",
                          transition: "0.2s",
                        }}
                      >
                        <img
                          src={Constants.imageDomain + img.image_path}
                          style={{
                            width: "100%",
                            height: 140,
                            objectFit: "cover",
                            opacity: isSelected ? 0.6 : 1,
                          }}
                        />

                        {isSelected && (
                          <div
                            style={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              background: "#1976d2",
                              color: "#fff",
                              borderRadius: "50%",
                              width: 24,
                              height: 24,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: 14,
                            }}
                          >
                            ✓
                          </div>
                        )}
                      </div>
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </div>

          {/* 🔥 Footer */}
          {this.state.selectedImages.length > 0 && (
            <div
              style={{
                borderTop: "1px solid #eee",
                paddingTop: 15,
                marginTop: 10,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <MDButton
                variant="contained"
                color="info"
                onClick={this.handleConfirm}
              >
                Select ({this.state.selectedImages.length})
              </MDButton>
            </div>
          )}
        </div>
      </Modal>
    );
  }
}